module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv1-f60ca4a56baffce72571c0c013fc4f2c.jpg";